import React, { Component } from 'react'
import { Table, Icon } from 'antd'
import { getAppSeting, postAppsetting, getPayRecommend,putPayRecommend} from '../../../api/api'
import './style.less'
export default class platform extends Component {
    state = {

    }
    componentDidMount() {
        getPayRecommend().then(res=>{
            console.log(res)
        })
        getAppSeting().then(res => {
            console.log(res)
            this.setState({
                data1: [],
                data2: [],
                data3: [],
                data4: [],
                data5: [],
            })
            res.data.map((v, k) => {
                switch (v.key) {
                    case 'ticketIntegralRate':
                        this.setState({
                            data5: [{ ticketIntegralRate: v.value }]
                        })
                        break;
                    case 'reward':
                        this.setState({
                            data1: [{ ...this.state.data1[0], reward: v.value }]
                        })
                        break;
                    case 'coupon1':
                        this.setState({
                            data1: [{ ...this.state.data1[0], coupon1: v.getValueInfo.name, id: v.getValueInfo.id }]
                        })
                        break;
                    case 'coupon2':
                        this.setState({
                            data1: [{ ...this.state.data1[0], coupon2: v.getValueInfo.name, id: v.getValueInfo.id }]
                        })
                        break;
                    case 'coupon3':
                        this.setState({
                            data1: [{ ...this.state.data1[0], coupon3: v.getValueInfo.name, id: v.getValueInfo.id }]
                        })
                        break;
                    case 'inviteCoupon':
                        this.setState({
                            data2: [{ inviteCoupon: v.getValueInfo.name, id: v.getValueInfo.id }]
                        })
                        break;
                    case 'ticket':
                        this.setState({
                            data3: [{ ...this.state.data3[0], ticket: v.getValueInfo.name, id: v.getValueInfo.id }]
                        })
                        break;
                    case 'goods1':
                        this.setState({
                            data3: [{ ...this.state.data3[0], goods1: v.getValueInfo.name, id: v.getValueInfo.id }]
                        })
                        break;
                    case 'goods2':
                        this.setState({
                            data3: [{ ...this.state.data3[0], goods2: v.getValueInfo.name, id: v.getValueInfo.id }]
                        })
                        break;
                    case 'goods3':
                        this.setState({
                            data3: [{ ...this.state.data3[0], goods3: v.getValueInfo.name, id: v.getValueInfo.id }]
                        })
                        break;
                    case 'goods3':
                        this.setState({
                            data3: [{ ...this.state.data3[0], goods3: v.getValueInfo.name, id: v.getValueInfo.id }]
                        })
                        break;
                    default:
                        break;
                }
            })
        })
    }

    render() {
        const columns = [
            {
                title: <span>积分</span>,
                dataIndex: 'reward',
                key: 'reward',
            },
            {
                title: <span>优惠券一</span>,
                dataIndex: 'coupon1',
                key: 'coupon1',
            },
            {
                title: <span>优惠券二</span>,
                dataIndex: 'coupon2',
                key: 'coupon2',
            },
            {
                title: <span>优惠券三</span>,
                dataIndex: 'coupon3',
                key: 'coupon3',
            },
        ]
        const columns1 = [
            {
                title: <span>优惠券</span>,
                dataIndex: 'inviteCoupon',
                key: 'inviteCoupon',
            },

        ]
        const columns2 = [
            // {
            //     title: '小程序汽车票支付优惠券',
            //     dataIndex: 'name',
            //     key: 'name',
            // },
            {
                title: <span>汽车票支付成功优惠券</span>,
                dataIndex: 'ticket',
                key: 'ticket',
            },

            {
                title: <span>商品支付成功优惠券一</span>,
                dataIndex: 'goods1',
                key: 'goods1',
            },

            {
                title: <span>商品支付成功优惠券二</span>,
                dataIndex: 'goods2',
                key: 'goods2',
            },

            {
                title: <span>商品支付成功优惠券三</span>,
                dataIndex: 'goods3',
                key: 'goods3',
            },
        ]
        const columns3 = [
            {
                title: <span>汽车票</span>,
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: <span>商品支付成功</span>,
                dataIndex: 'orderCount',
                key: 'orderCount',
            },
        ]
        const columns4 = [
            {
                title: <span>汽车积分抵扣率</span>,
                dataIndex: 'ticketIntegralRate',
                key: 'ticketIntegralRate',
            },
        ]
        return (
            <div className='merchants-page'>

                <div className='tablecontain'>
                    <div className='contain-title'>
                        <Icon type="unordered-list" /> 新用户注册礼包</div>
                    <Table
                        bordered
                        columns={columns}
                        dataSource={this.state.data1}
                        pagination={false}
                        rowKey='id'
                    />
                </div>
                <div className='tablecontain'>
                    <div className='contain-title'>
                        <Icon type="unordered-list" /> 邀请成功礼包</div>
                    <Table
                        bordered
                        columns={columns1}
                        dataSource={this.state.data2}
                        pagination={false}
                        rowKey='id'
                    />
                </div>
                <div className='tablecontain'>
                    <div className='contain-title'>
                        <Icon type="unordered-list" /> 支付成功优惠券</div>
                    <Table
                        bordered
                        columns={columns2}
                        dataSource={this.state.data3}
                        pagination={false}
                        rowKey='id'
                    />
                </div>
                <div className='tablecontain'>
                    <div className='contain-title'>
                        <Icon type="unordered-list" /> 支付成功推荐</div>
                    <Table
                        bordered
                        columns={columns3}
                        dataSource={this.state.data4}
                        pagination={false}
                        rowKey='id'
                    />
                </div>
                <div className='tablecontain'>
                    <div className='contain-title'>
                        <Icon type="unordered-list" /> 其他设置</div>
                    <Table
                        bordered
                        columns={columns4}
                        dataSource={this.state.data5}
                        pagination={false}
                        rowKey='id'
                    />
                </div>
            </div>
        )
    }
}

